import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Grid,
  Typography,
  CircularProgress
} from "@mui/material";

type Props = {
  open: boolean;
  isLoading: boolean;
  isEdit: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filledLanguages: string[];
};

export const ConfirmLanguagesDialog: React.FC<Props> = ({
  open,
  isLoading,
  isEdit,
  onClose,
  onConfirm,
  filledLanguages
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Submission</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Content has been filled for the following languages:
        </DialogContentText>

        <Grid container spacing={2}>
          {filledLanguages.map((lang, index) => (
            <Grid item xs={3} key={index}>
              <Typography
                variant="body2"
                sx={{
                  p: 1,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  textAlign: "center",
                  backgroundColor: "#f9f9f9"
                }}
              >
                {lang}
              </Typography>
            </Grid>
          ))}
        </Grid>

        <DialogContentText sx={{ mt: 3 }}>
          Are you sure you want to proceed with submission?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          No, Add more
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={16} /> : null}
        >
          {isEdit ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
